import React from 'react'
import { Segment } from 'semantic-ui-react'

import { monthMapper } from 'libs/month-mapper'
import { UpdatePaymentModal } from './updatePaymentModal'
import { AllowPermission } from 'shared/components/AllowPermission'
import constants from 'config/constants'

/**
 *
 * @param {object} props
 * @param {object} props.card
 */
export function PaymentInfoContainer({ card, billing }) {
  if (!card) {
    return (
      <React.Fragment>
        <h3>Payment method</h3>
        <NoPaymentInfo billing={billing} />
      </React.Fragment>
    )
  }
  return (
    <React.Fragment>
      <h3>Payment method</h3>
      <PaymentInfo card={card} billing={billing} />
    </React.Fragment>
  )
}

function PaymentInfo({ card, billing }) {
  return (
    <table className="ui compact collapsing celled table">
      <thead>
        <tr>
          <th>Card</th>
          <th colSpan={2}>Expires</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <i className="far fa-credit-card icon" /> {card.brand} ending in {card.last4}
          </td>
          <td>{`${monthMapper(card.exp_month)} ${card.exp_year}`}</td>
          <AllowPermission permission={constants.permissions.manageBillingInformation}>
            <td>
              <UpdatePaymentModal label="Update card" billing={billing} />
            </td>
          </AllowPermission>
        </tr>
      </tbody>
    </table>
  )
}

function NoPaymentInfo({ billing }) {
  return (
    <div className="ui grid">
      <div className="twelve wide column">
        <Segment>
          <p>No payment method added yet.</p>
          <AllowPermission permission={constants.permissions.manageBillingInformation}>
            <UpdatePaymentModal label="Add a card" billing={billing} />
          </AllowPermission>
        </Segment>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/Billing/paymentInfo.js